import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../configs/api";
import AmenitiesProject from "../../../../components/public/userProjectDetails/AmenitiesProject";
import ProjectDetailsCard from "../../../../components/public/userProjectDetails/ProjectDetailsCard";
import FloorPlan from "../../../../components/public/userProjectDetails/FloorPlan";
import Brochure from "../../../../components/public/userProjectDetails/Brochure";
import Specification from "../../../../components/public/userProjectDetails/Specification";
import PaymentSchedule from "../../../../components/public/userProjectDetails/PaymentSchedule";
import ProjectFacilities from "../../../../components/public/userProjectDetails/ProjectFacilities";
import ProjectAboutLacasa from "../../../../components/public/userProjectDetails/ProjectAboutLacasa";
import ContactForm from "../../../../components/public/userCommon/ContactForm";
import { MapEmbed } from "../../../../components/admin/common/details-components";
import { formatPrettyAddress } from "../../../../utils/helpers";

const AdminProjectPropertyDetails = () => {
  const { id } = useParams();

  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchProjectById = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/properties/${id}`);
      console.log("project data:", response?.data?.data);
      if (response.data?.data) {
        setProjectData(response.data.data);
      } else {
        setError("Project data not found.");
      }
    } catch (err) {
      console.error("Error fetching project details:", err);
      setError("Failed to fetch project details.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchProjectById();
  }, [id]);

  // Handle loading state
  if (loading) {
    return (
      <div className="flex  justify-center items-center min-h-screen text-gray-600">
        Loading project details...
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <div className="flex justify-center items-center min-h-screen text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className="overflow-hidden">
      <ProjectDetailsCard projectData={projectData} />

      <div className="grid grid-cols-1 lg:grid-cols-4 px-4 sm:px-6 lg:px-8 xl:px-10 gap-4 sm:gap-6 md:gap-8">
        <div className="col-span-3 space-y-6 md:space-y-8 lg:space-y-10 pb-6 md:pb-8 lg:pb-10">
          <ProjectAboutLacasa
            description={projectData.description}
            builderName={projectData.property?.builderName}
          />
          <FloorPlan floorPlan={projectData.property?.floorPlan} />
          <AmenitiesProject amenities={projectData.property?.amenities || []} />
          <Brochure brochureUrl={projectData.property?.brochureUrl} />
          <MapEmbed
            className={"h-[25rem] w-full"}
            coordinates={projectData?.location?.coordinates}
            address={formatPrettyAddress(projectData?.location)}
          />
          <Specification
            specification={projectData.property?.specification || []}
          />
          <PaymentSchedule
            paymentSchedule={projectData?.property?.paymentSchedule}
          />
          <ProjectFacilities
            facilities={projectData.property?.facilities || []}
          />
        </div>
        <div className="col-span-1">
          <ContactForm
            propertyId={projectData._id}
            propertyTitle={projectData.title}
            listedBy={projectData.listedBy}
          />
        </div>
      </div>
    </div>
  );
};

export default AdminProjectPropertyDetails;
